///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.sponsorships = abcsetup.thoughtspot.sponsorships || {};
abcsetup.thoughtspot.sponsorships.edit = abcsetup.thoughtspot.sponsorships.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.sponsorships.edit = {
    init() {
        abcsetup.setTitle('Edit a Sponsorship');

        $('textarea.editor').each(function() {
            CKEDITOR.create($(this)[0], CKEDITOR.config);
        });
    },
}
